/* src/app/modules/employees/childUsers/child-users.component.css */
:host {
  --cu-brand: #e3fd64;
  --cu-brand-d: #4d7a00;
  --cu-text: #1a1d23;
  --cu-muted: #6b7280;
  --cu-border: #e5e7eb;
  --cu-surface: #ffffff;
  --cu-radius: 10px;
  --cu-shadow: 0 2px 8px rgba(0,0,0,0.07);
}
.cu-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.cu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.cu-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.cu-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(227, 253, 100, 0.12);
  flex-shrink: 0;
}
.cu-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.cu-header__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: var(--cu-text);
  line-height: 1.2;
}
.cu-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--cu-muted);
}
.cu-layout {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 20px;
  align-items: start;
}
@media (max-width: 860px) {
  .cu-layout {
    grid-template-columns: 1fr;
  }
}
.cu-sidebar {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.cu-card {
  background: var(--cu-surface);
  border: 1px solid var(--cu-border);
  border-radius: var(--cu-radius);
  box-shadow: var(--cu-shadow);
  overflow: hidden;
}
.cu-card--create {
  border-top: 3px solid var(--cu-brand);
}
.cu-card__head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  border-bottom: 1px solid var(--cu-border);
  background: #f9fafb;
}
.cu-card__head-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--cu-brand);
}
.cu-card__head-title {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--cu-text);
}
.cu-form {
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.cu-field {
  width: 100%;
}
.cu-field .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.cu-prefix {
  color: var(--cu-muted);
  margin-right: 6px;
}
.cu-btn-primary {
  background-color: var(--cu-brand) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.cu-btn-primary:hover {
  background-color: var(--cu-brand-d) !important;
}
.cu-btn-primary--full {
  width: 100%;
  justify-content: center;
  margin-top: 4px;
}
.cu-btn-danger {
  color: #dc2626 !important;
  border-color: #dc2626 !important;
}
.cu-list {
  list-style: none;
  padding: 8px 0;
  margin: 0;
}
.cu-list__item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  cursor: pointer;
  transition: background 0.12s;
  border-left: 3px solid transparent;
}
.cu-list__item:hover {
  background: #fafafa;
}
.cu-list__item--active {
  background: rgba(227, 253, 100, 0.06);
  border-left-color: var(--cu-brand);
}
.cu-list__info {
  flex: 1;
  min-width: 0;
}
.cu-list__name {
  display: block;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--cu-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cu-list__email {
  display: block;
  font-size: 12px;
  color: var(--cu-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cu-list__arrow {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--cu-border);
  transition: color 0.12s, transform 0.12s;
}
.cu-list__item--active .cu-list__arrow {
  color: var(--cu-brand);
  transform: translateX(2px);
}
.cu-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(227, 253, 100, 0.15);
  color: var(--cu-brand-d);
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  text-transform: uppercase;
}
.cu-avatar--lg {
  width: 46px;
  height: 46px;
  font-size: 17px;
}
.cu-empty {
  padding: 28px 16px;
  text-align: center;
  color: var(--cu-muted);
}
.cu-empty mat-icon {
  font-size: 36px;
  width: 36px;
  height: 36px;
  display: block;
  margin: 0 auto 8px;
  color: var(--cu-border);
}
.cu-empty p {
  margin: 0;
  font-size: 13px;
}
.cu-empty-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 48px;
  background: var(--cu-surface);
  border: 1px solid var(--cu-border);
  border-radius: var(--cu-radius);
  box-shadow: var(--cu-shadow);
  text-align: center;
}
.cu-empty-main__art {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 18px;
  background: rgba(227, 253, 100, 0.1);
  margin-bottom: 20px;
}
.cu-empty-main__art mat-icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
  color: var(--cu-brand);
}
.cu-empty-main__title {
  margin: 0 0 8px;
  font-size: 17px;
  font-weight: 600;
  color: var(--cu-text);
}
.cu-empty-main__sub {
  margin: 0;
  font-size: 13.5px;
  color: var(--cu-muted);
  line-height: 1.6;
  max-width: 260px;
}
.cu-perm {
  background: var(--cu-surface);
  border: 1px solid var(--cu-border);
  border-radius: var(--cu-radius);
  box-shadow: var(--cu-shadow);
  overflow: hidden;
}
.cu-perm__header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 22px;
  background: #f9fafb;
  border-bottom: 1px solid var(--cu-border);
}
.cu-perm__name {
  margin: 0 0 2px;
  font-size: 16px;
  font-weight: 700;
  color: var(--cu-text);
}
.cu-perm__email {
  margin: 0;
  font-size: 12.5px;
  color: var(--cu-muted);
}
.cu-perm__close {
  margin-left: auto;
  color: var(--cu-muted) !important;
}
.cu-perm__pw-row {
  padding: 14px 22px;
  border-bottom: 1px solid var(--cu-border);
}
.cu-perm__pw-form {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 22px;
  border-bottom: 1px solid var(--cu-border);
  flex-wrap: wrap;
}
.cu-perm__pw-form .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.cu-perm__section-title {
  margin: 0 0 14px;
  font-size: 13px;
  font-weight: 700;
  color: var(--cu-muted);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.cu-perm-group {
  padding: 16px 22px;
  border-bottom: 1px solid var(--cu-border);
}
.cu-perm-group:last-of-type {
  border-bottom: none;
}
.cu-perm-group__label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--cu-muted);
}
.cu-perm-group__label mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: var(--cu-brand);
}
.cu-perm-group__items {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 10px 24px;
}
.cu-toggle-item {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.cu-toggle-item ::ng-deep .mdc-label {
  font-size: 13.5px;
  color: var(--cu-text);
  cursor: pointer;
}
.cu-perm__actions {
  padding: 16px 22px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  background: #f9fafb;
  border-top: 1px solid var(--cu-border);
}
.cu-delete-confirm {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 10px 14px;
  background: #fff1f2;
  border: 1px solid rgba(220, 38, 38, 0.2);
  border-radius: 8px;
  flex: 1;
}
.cu-delete-confirm__text {
  font-size: 13px;
  color: #dc2626;
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}
/*# sourceMappingURL=child-users.component.css.map */
